<template>
  <div class="sky-cascader">
    <sky-suffix :suffix="suffix" v-bind="$attrs">
      <el-cascader
        class="casca"
        v-bind="$attrs"
        :options="options"
        v-model="selfData"
        :props="getProp"
        clearable
        :size="size"
        :show-all-levels="showAllLevels"
        :placeholder="placeholder"
        @change="change"
      ></el-cascader>
    </sky-suffix>
  </div>
</template>
<script>
/**
 * @author David
 * @Date 2019/6/17
 */
import formStore from '@/mixins/formStore.js';
import skySuffix from '@/components/iglobalwin/formComponents/SkySuffix.vue';

export default {
  props: {
    options: {
      default: () => [],
    },
    props: { require: false },
    size: {
      default: '',
    },
    suffix: Object,
    showAllLevels: {
      //是否显示选中值的完整路径
      default: false,
    },
    checkStrictly: {
      //是否父子节点不关联
      default: true,
    },
    placeholder: {
      default: '请输入关键字',
      type: String,
    },
  },
  mixins: [formStore],
  components: {
    skySuffix,
  },
  computed: {
    getProp() {
      let self = this;
      return Object.assign({}, this.props, {
        checkStrictly: self.checkStrictly,
        emitPath: false,
      });
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.casca {
  width: 100%;
}
</style>
